import { useEffect, useRef, useState } from 'react';
import { useConfig } from '../../../../contexts/config-context';
import { useFieldActions } from '../../../../contexts/field-actions-context';
import { bulkSlotsSize, DataStatus, ErrorTypes } from '../../appointment-state';
import { Actions, Components } from '../../bi-types';
import { useAppointmentBi } from '../../utils/bi';
import { calculateSelectedDate, getStartAndEndDate, getUserTimezone } from './utils';
export default function useInitialAppointmentState(props) {
    const { initialData: loadInitialAppointmentDataResponse, onChange, value: selectedSlotFromProps } = props;
    const { isEditor, isComposer } = useConfig();
    const serviceId = loadInitialAppointmentDataResponse?.service?.id;
    const { actions } = useFieldActions();
    const actionsRef = useRef(actions);
    actionsRef.current = actions;
    const hasAvailabilityActions = Boolean(actions?.getAvailabilityDates && actions?.getAvailabilitySlots);
    const [appointmentState, setAppointmentState] = useState(null);
    const bi = useAppointmentBi(loadInitialAppointmentDataResponse?.service);
    useEffect(()=>{
        const initialAppointmentState = async ()=>{
            const timezone = getUserTimezone();
            const appointmentStateResult = {
                currentSlotBulkSize: bulkSlotsSize,
                timezone,
                dataStatus: DataStatus.LOADING
            };
            try {
                const fetchAvailabilityDates = async (range)=>{
                    const { startDate, endDate } = getStartAndEndDate(range, timezone);
                    return actionsRef.current?.getAvailabilityDates?.({
                        serviceId: serviceId,
                        fromDate: startDate,
                        toDate: endDate,
                        timeZone: timezone
                    });
                };
                appointmentStateResult.availabilityDates = await fetchAvailabilityDates(2);
                if (!appointmentStateResult.availabilityDates?.length) {
                    appointmentStateResult.availabilityDates = await fetchAvailabilityDates(6);
                }
                if (!appointmentStateResult.availabilityDates?.length) {
                    bi?.report({
                        action: Actions.LOAD,
                        component: Components.NO_AVAILABILITY_AT_ALL
                    });
                    setAppointmentState({
                        dataStatus: DataStatus.ERROR,
                        error: {
                            type: ErrorTypes.NO_AVAILABILITY_DATES_FOUND,
                            message: 'No availability dates found'
                        }
                    });
                    return;
                }
                appointmentStateResult.selectedDate = calculateSelectedDate(appointmentStateResult.availabilityDates);
                if (appointmentStateResult.selectedDate) {
                    appointmentStateResult.availabilitySlots = await actionsRef.current?.getAvailabilitySlots?.({
                        serviceId: serviceId,
                        timeZone: timezone,
                        selectedDate: appointmentStateResult.selectedDate
                    });
                }
                bi?.report({
                    action: Actions.LOAD,
                    component: appointmentStateResult.availabilityDates?.length ? Components.FORM : Components.NO_AVAILABILITY_FOR_DATE
                });
                if (!selectedSlotFromProps?.startDate) {
                    onChange(undefined);
                }
                setAppointmentState({
                    ...appointmentStateResult,
                    dataStatus: DataStatus.DONE
                });
            } catch (error) {
                console.error(error);
                setAppointmentState({
                    dataStatus: DataStatus.ERROR,
                    error: {
                        type: ErrorTypes.GENERAL,
                        message: 'An error occurred in initialAppointmentState'
                    }
                });
            }
        };
        if (serviceId && !isEditor && !isComposer && hasAvailabilityActions) {
            initialAppointmentState();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditor,
        isComposer,
        serviceId,
        hasAvailabilityActions
    ]);
    return appointmentState;
}

//# sourceMappingURL=index.js.map